import React from "react";
import classes from "./css/About.module.css";

const About = () => {
    console.log("Running About");
  return (
    <div className={classes.page}>
      <div className={classes.container}>
        <p>
          <br />
          <h1>About Byte79 Ltd</h1>
          <b>Byte79 Ltd</b> is a software development company with over 35 years of experience in the industry. We specialize in creating innovative software solutions, including mobile applications, web applications, middleware, and database integration. Our team is dedicated to delivering high-quality, reliable, and scalable software that meets the needs of our clients.
       
         

        </p>
      </div>
    </div>
  );
};

export default About;
